export default "/images/b7c98b00076ca7d24ac435554854d179.avif";